import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    lastFeatureCta: 'Request a card',
  },
  fr: {
    lastFeatureCta: 'Demander une carte',
  },
} as const);

export default locales;
